var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1086_26017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 0.25H2.25C1.14543 0.25 0.25 1.14543 0.25 2.25V13.75C0.25 14.8546 1.14543 15.75 2.25 15.75H21.75C22.8546 15.75 23.75 14.8546 23.75 13.75V2.25C23.75 1.14543 22.8546 0.25 21.75 0.25Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79 5.91C2.22576 5.60811 1.62379 5.38279 1 5.24L1.03 5.11H3.76C4.14 5.12 4.44 5.24 4.53 5.63L5.13 8.47L5.31 9.32L6.98 5.12H8.78L6.1 11.27H4.3L2.8 5.9L2.79 5.91ZM10.1 11.28H8.4L9.46 5.11H11.16L10.1 11.28ZM16.27 5.26L16.04 6.6L15.88 6.53C15.58 6.41 15.17 6.28 14.61 6.29C13.94 6.29 13.64 6.56 13.63 6.83C13.63 7.11 14 7.3 14.59 7.59C15.57 8.03 16.03 8.57 16.02 9.27C16.01 10.55 14.85 11.37 13.06 11.37C12.3 11.37 11.56 11.22 11.16 11.05L11.4 9.66L11.63 9.76C12.18 9.99 12.54 10.09 13.23 10.09C13.71 10.09 14.23 9.89 14.24 9.49C14.24 9.22 14.02 9.02 13.36 8.72C12.72 8.42 11.86 7.92 11.87 7.04C11.87 5.84 13.07 5 14.74 5C15.4 5 15.94 5.14 16.27 5.26ZM18.53 9.1H19.94L19.55 7.31L19.43 6.78L19.21 7.38L18.53 9.1ZM20.63 5.11L22 11.28H20.42L20.22 10.36H18.04L17.68 11.28H15.9L18.42 5.62C18.6 5.22 18.91 5.12 19.32 5.12H20.62L20.63 5.11Z",
    fill: "#1434CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1086_26017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa-logo.57565985f1b939fea694407d1f8cfa73.svg";
export { ForwardRef as ReactComponent };